import React from 'react';
import * as d3 from 'd3';
import ChartComponent from './ChartComponent';

const YAxis = ({ yScale, tickFormat }) => {
    function draw(chart) {
        const axis = d3.axisLeft(yScale);
        if (tickFormat) {
            axis.tickFormat(tickFormat);
        }
        chart.attr('class', 'Axis__y')
            .call(axis);
    }

    return (
        <ChartComponent
            draw={draw}
        />
    )
}

export default YAxis
